import styled from '@emotion/styled'

export const SubjectSummaryWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`
